<template>
  <span>
    <icon v-if="!down" name="caret-up" class="pull-down-button__arrowPosition" scale="1.2"></icon>
    <icon v-else name="caret-down" class="pull-down-button__arrowPosition" scale="1.2"></icon>
  </span>
</template>

<script>
import 'vue-awesome/icons/caret-down'
import 'vue-awesome/icons/caret-up'
import Icon from 'vue-awesome/components/Icon'

export default {
  components: {
    Icon
  },
  props: {
    down: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// CollapseArrows.vue?6f171332